import { BARS_MAX_HEIGHT } from "@Constants/bars";
import classNames from "classnames";

type BarsProps = {
  values: number[];
  unit?: string;
  scalingFactor?: number;
  barBackgroundColorClassName?:
    | "m:bg-blue-500"
    | "m:bg-special-wind-bar"
    | "m:bg-special-snow-bar";
  withDivider?: boolean;
};

export const Bars = ({
  values,
  unit,
  scalingFactor = 1.0,
  barBackgroundColorClassName = "m:bg-blue-500",
  withDivider = false,
}: BarsProps) => {
  return (
    <div
      className={classNames(
        "m:m-0 m:grid m:h-9 m:max-h-9 m:min-h-9 m:auto-cols-[1fr] m:auto-rows-[1fr] m:before:absolute m:before:top-auto m:before:left-0 m:before:z-0 m:before:mt-[5px] m:before:h-9 m:before:max-h-9 m:before:min-h-9 m:before:w-full m:before:bg-rainbars-gradient m:before:bg-[length:100%_6px] m:before:bg-repeat m:before:content-[''] m:dark:before:bg-rainbars-gradient-dark",
      )}>
      {values.map((value, index) => {
        const scaledValue = Math.round(value * scalingFactor);

        const rowStart = Math.max(BARS_MAX_HEIGHT - scaledValue + 1, 1);
        const rowSpan = Math.min(scaledValue, BARS_MAX_HEIGHT);
        const column = index + 1;

        return (
          <div
            key={index}
            className={classNames(
              "m:z-1 m:flex m:h-full m:flex-col-reverse m:bg-blue-500",
              barBackgroundColorClassName,
              {
                "m:mr-[1px] m:w-[calc(100%-1px)]": withDivider,
                "m:mr-0 m:w-full": !withDivider,
                "m:invisible": scaledValue === 0,
              },
            )}
            title={`${value}${unit ? ` ${unit}` : ""}`}
            style={{
              gridRow: `${rowStart} / span ${rowSpan}`,
              gridColumn: column,
            }}
          />
        );
      })}
    </div>
  );
};
